import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { environment } from 'src/environments/environment';
import { CommonServiceService } from '../services/common-service.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  show = false;
  showSecondPass = false;
  userAllData: any = [];
  newPassword = '';
  confPassword = '';
  transactionID: any;
  isNewPassword = false;
  isStrongPassword = false;
  isConformPassword = false;
  decodedEmail = '';

  constructor(
    private commonService: CommonServiceService, private route: ActivatedRoute,
    private router: Router, private snackBar: MatSnackBar
  ) {
    this.route.queryParamMap.subscribe((res: any) => {
      if (res && res.params && res.params.data){
        this.decodedEmail = atob(res.params.data);
      }
    });
   }

  ngOnInit(): void {
    this.transactionID = this.route.snapshot.params.id;
  }

  showPassword(): void {
    this.show = !this.show;
  }

  showConfirmPassword(): void {
    this.showSecondPass = !this.showSecondPass;
  }

  resetPassword(): void {
    if (this.newPassword === '' || this.confPassword === ''){
      this.openSnackBar(['Fields can not be empty !'], 3000);
      return;
    }
    if (this.newPassword !== this.confPassword){
      this.openSnackBar(['Password mismatch !'], 3000);
      return;
    }
    const random = Math.random();
    const cipherText1 = this.commonService.getSecratKey(environment.secratKey, this.newPassword);
    const cipherText2 = this.commonService.getSecratKey(environment.secratKey, this.confPassword);
    const payload = {
      txn_id: this.transactionID,
      password: cipherText1,
      confirm_password: cipherText2
    };
    this.commonService.resetPassword(payload).subscribe(res => {
      if (res.success){
        this.commonService.formPostMethod({
          txn_id: this.transactionID,
          password: this.newPassword
        }, 'user/update-formio-password').subscribe((updateRes: any) => {
          this.openSnackBar(['Password Updated Successfully'], 3000);
        },
          (error: any) => {
            this.openSnackBar([error?.error?.message || 'Failed !'], 3000);
          });
      }
    }, error => {
      this.openSnackBar([error?.error?.message ? error?.error?.message : 'failed !'], 3000);
    });
  }

  openSnackBar(data: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }
  passwordMethod(): void {
    if (!this.newPassword){
      this.isNewPassword =  true;
    }
    else{
      this.isNewPassword =  false;
      this.passwordValidator();
    }
  }
  passwordMatchMethod(): void {
    if (this.newPassword === this.confPassword){
      this.isConformPassword = false;
    }
    else{
      this.isConformPassword = true;
    }

  }
  passwordValidator(): void {
    const value = this.newPassword;
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasSpace = /\s/g.test(value);
    const isLengthValid = value.length >= 8;
    this.isStrongPassword = hasNumber && hasSpecialChar && hasUpperCase && hasLowerCase && isLengthValid && !hasSpace;
  }


}
